// src/App.tsx

import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { NotificacaoProvider } from "./context/NotificacaoContext";

import LoginPage from "./LoginPage";
import Subscription from "./pages/Subscription"; // Added import for RegisterPage
import AppLayout from "./AppLayout";
import { ThemeContextProvider } from "./components/theme/ThemeContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Diretrizes from "./pages/Diretrizes";
import AmbienteExterno from "./pages/AmbienteExterno";
import AmbienteInterno from "./pages/AmbienteInterno";
import MetasGlobais from "./pages/MetaGlobal";
import Metas from "./pages/Metas";
import PlanoDeAcao from "./pages/PlanoDeAcao";
// import Avaliacao from "./pages/⁠Avaliacao";
import LandingPage from "./pages/LandingPage";
import SelecaoEmpresa from "./SelecaoEmpresa";
import Swot from "./pages/Swot";
import Profile from './pages/Profile';
import Notificacoes from './pages/Notificacoes';
import DemoAutoLogin from './pages/DemoAutoLogin';
import PitchDeck from './pages/PitchDeck';
import PitchNascer from './pages/PitchNascer';
import PitchPdf from './pages/PitchPdf';
import Pagamento from './pages/Pagamento';
import PagamentoSucesso from './pages/PagamentoSucesso';
import ResetPasswordPage from './pages/ResetPasswordPage';

// Components
import Desdobramento from "./pages/Desdobramento";
import Colaboradores from "./pages/Colaboradores";
import Dashboard from "./pages/Dashboard";
import CadastroPerfis from "./pages/CadastroPerfis";
import Configuracoes from "./pages/Configuracoes";
import AdminDashboard from "./pages/AdminDashboard";
import AdminRoute from "./components/AdminRoute";
import Auditoria from "./pages/Auditoria";

const App: React.FC = () => {
  // const [isConviteSelecionado, setIsConviteSelecionado] = useState<Convite>();

  // useEffect(() => {
  //   const conviteSelecionado = localStorage.getItem("conviteSelecionado") ? JSON.parse(localStorage.getItem("conviteSelecionado") as string) : null;
  //   setIsConviteSelecionado(conviteSelecionado);
  // }, []);

  // Define the AppContent component that uses the auth hooks
  const AppContent = () => {
    const { loading, signed } = useAuth();

    if (loading) {
      return <div>Loading...</div>;
    }

    return (
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/tw/login" element={<LoginPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/tw/demo-login" element={<DemoAutoLogin />} />
        <Route path="/tw/register" element={<Subscription />} /> {/* Added register route */}
        <Route path="/tw/pitch" element={<PitchDeck />} /> {/* Pitch Deck route */}
        <Route path="/tw/pitch-video" element={<PitchNascer />} /> {/* Pitch Nascer route */}
        <Route path="/tw/pitch-pdf" element={<PitchPdf />} /> {/* Pitch PDF route */}
        <Route path="/tw/selecao-empresa" element={<SelecaoEmpresa />} />

        {/* Protected routes */}
        <Route
          path="/tw"
          element={
            signed ? (
              <AppLayout isAuthenticated={signed} />
            ) : (
              <Navigate to="/tw/login" />
            )
          }
        >
          {/* Rotas que requerem assinatura ativa */}
          <Route path="dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="diretrizes" element={<ProtectedRoute><Diretrizes /></ProtectedRoute>} />
          <Route path="colaboradores" element={<ProtectedRoute><Colaboradores /></ProtectedRoute>} />
          <Route path="ambiente-externo" element={<ProtectedRoute><AmbienteExterno /></ProtectedRoute>} />
          <Route path="ambiente-interno" element={<ProtectedRoute><AmbienteInterno /></ProtectedRoute>} />
          <Route path="pontos-fortes" element={<ProtectedRoute><AmbienteInterno /></ProtectedRoute>} />
          <Route path="pontos-fracos" element={<ProtectedRoute><AmbienteInterno /></ProtectedRoute>} />
          <Route path="metas-globais" element={<ProtectedRoute><MetasGlobais /></ProtectedRoute>} />
          <Route path="metas" element={<ProtectedRoute><Metas /></ProtectedRoute>} />
          <Route path="plano-de-acao" element={<ProtectedRoute><PlanoDeAcao /></ProtectedRoute>} />
          <Route path="swot" element={<ProtectedRoute><Swot /></ProtectedRoute>} />
          <Route path="desdobramento" element={<ProtectedRoute><Desdobramento /></ProtectedRoute>} />
          <Route path="notificacoes" element={<ProtectedRoute><Notificacoes /></ProtectedRoute>} />
          <Route path="perfis" element={<ProtectedRoute><CadastroPerfis /></ProtectedRoute>} />
          <Route path="configuracoes" element={<ProtectedRoute><Configuracoes /></ProtectedRoute>} />
          <Route path="auditoria" element={<ProtectedRoute><Auditoria /></ProtectedRoute>} />
          <Route path="admin" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
          
          {/* Rotas que NÃO requerem assinatura (podem acessar sem pagar) */}
          <Route path="profile" element={<Profile />} />
          <Route path="pagamento" element={<Pagamento />} /> {/* Página de Pagamento */}
          <Route path="pagamento/sucesso" element={<PagamentoSucesso />} /> {/* Página de Sucesso */}
          {/* <Route path="avaliacao" element={<Avaliacao />} /> */}
          {/* <Route path="relatorios" element={<Relatorios />} /> */}
        </Route>
      </Routes>
    );
  };

  return (
    <ThemeContextProvider>
      {/* Removido o ThemeProvider duplicado */}
      <Router>
        <AuthProvider>
          <NotificacaoProvider>
              <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
                style={{ zIndex: 9999 }}
              />
              <AppContent />
            </NotificacaoProvider>
        </AuthProvider>
      </Router>
    </ThemeContextProvider>
  );
};

export default App;
